import React from 'react';
import { User } from 'iconoir-react';
import { VARIANT_CHIP, formatDateTime } from './trackingUtils';

const Row = ({ label, value }) => (
    <div className="flex flex-col sm:flex-row sm:gap-4 py-2 border-b border-colorsixth last:border-0">
        <dt className="sm:w-40 shrink-0 text-sm text-gray-500 text-left">{label}</dt>
        <dd className="flex-1 text-sm text-colorfourth text-left [overflow-wrap:anywhere]">{value}</dd>
    </div>
);

const Card = ({ title, children }) => (
    <section className="bg-white border border-colorfifth rounded-xl p-4 md:p-5 text-left">
        <h6 className="font-semibold text-colorfourth text-left mb-3">{title}</h6>
        {children}
    </section>
);

export const CurrentStatus = ({ estado, asignacion = {} }) => {
    const chip = VARIANT_CHIP[estado?.variant] || VARIANT_CHIP.active;
    const updatedAt = formatDateTime(estado?.updated_at);

    return (
        <Card title="Estado actual">
            <div className={`rounded-lg border px-3 py-2 mb-3 ${chip}`}>
                <div className="text-sm font-semibold">{estado?.label}</div>
                {estado?.description && <div className="text-sm mt-0.5">{estado.description}</div>}
            </div>
            <dl>
                {updatedAt && <Row label="Actualizado" value={updatedAt} />}
                <Row
                    label="Técnico asignado"
                    value={
                        asignacion.tecnico ? (
                            <span className="inline-flex items-center gap-1.5 font-medium">
                                {asignacion.tecnico}
                            </span>
                        ) : (
                            <span className="italic text-gray-400 mb-0">Aún no se ha asignado un técnico</span>
                        )
                    }
                />
                {/* TODO: habilitar cuando SIGT entregue estos datos (hoy solo llega el nombre del técnico)
                {asignacion.vehiculo && <Row label="Vehículo / Medio" value={asignacion.vehiculo} />}
                {asignacion.telefono && <Row label="Teléfono" value={asignacion.telefono} />}
                */}
                {/* TODO: "Tiempo en sitio" y "Tiempo estimado de finalización" (sin definición en la API) */}
            </dl>
            {/* TODO: botón "Contactar técnico" cuando capabilities.contact_technician sea true y exista asignacion.telefono */}
        </Card>
    );
};

export const RequestSummary = ({ resumen = {}, ordenId }) => {
    const rows = [
        ['Orden de trabajo', ordenId],
        ['Servicio', resumen.servicio],
        ['Cliente', resumen.cliente],
        ['Dirección', resumen.direccion],
        ['Ciudad', resumen.ciudad],
        ['Tipo de trabajo', resumen.tipo_trabajo],
        ['Fecha de solicitud', formatDateTime(resumen.fecha_solicitud)],
        ['Fecha de la orden', formatDateTime(resumen.fecha_orden)],
        ['Fecha de la cita', formatDateTime(resumen.fecha_cita)],
        ['Observaciones', resumen.observaciones],
    ].filter(([, value]) => value);

    return (
        <Card title="Información de la solicitud">
            {rows.length === 0 ? (
                <p className="text-sm text-gray-400">Sin información disponible.</p>
            ) : (
                <dl>{rows.map(([label, value]) => <Row key={label} label={label} value={value} />)}</dl>
            )}
            {/* TODO: prioridad y SLA comprometido cuando capabilities.show_sla sea true */}
        </Card>
    );
};
